import { FC, ComponentProps } from 'react'
import { Button } from 'components/primitives'
import { CSS } from '@stitches/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'

type Props = {
  token?: any
  orderId?: string
  buttonCss?: CSS
  buttonProps?: ComponentProps<typeof Button>
}

// PARKED: cart checkout executed via Reservoir — paused during the Alchemy migration.
const AddToCart: FC<Props> = () => {
  // HIDDEN during the browse-only relaunch: native trading is parked, so these
  // controls render nothing. Buying happens via the OpenSeaButton outbound link.
  // To restore, render <TradePausedButton .../> again in the component body below.
  return null
}

export default AddToCart
